import { createFileRoute } from '@tanstack/react-router'
import { noop } from '@tanstack/react-query'
import { trpc } from '@/main'

// Pathless layout that OWNS the window-keyed session query, so widening the window re-keys THIS match, not the page.
export const Route = createFileRoute('/_app/admin/sessions_/$sessionId/_timeline')({
  loaderDeps: ({ search }) => ({ at: search.at, wide: search.wide }),
  context: ({ params, deps }) => ({
    sessionQueryOptions: trpc.admin.getSession.queryOptions({
      sessionId: params.sessionId,
      at: deps.at,
      wide: deps.wide || undefined,
    }),
  }),
  loader: ({ context }) => {
    context.queryClient.query(context.sessionQueryOptions).catch(noop)
  },
})
